import React, { useState } from 'react';
import { FormProvider, type SubmitHandler, useForm } from 'react-hook-form';

import { ModalDefault } from '../../../../components/ModalDefault/ModalDefault';
import { ControlledInput } from '../../../../components/ControlledInput/ControlledInput';
import { Button } from '../../../../components/Button/Button';
import { Loading } from '../../../../components/Loading/Loading';
import { usePatchTgSessionMutation } from '../../../../redux/services/TgSessionsApi';
import { type TgSession } from '../../../../redux/types/TgSessionsTypes';
import { RequisitesSelect } from './RequisitesSelect';
import { getErrorText } from './helpers';
import styles from '../TgSessions.module.css';

interface EditSessionModalProps {
  active: boolean;
  setActive: (value: boolean) => void;
  session: TgSession;
}

const EditSessionModal = ({ active, setActive, session }: EditSessionModalProps) => {
  const formMethods = useForm<{ label: string }>({ mode: 'onChange', defaultValues: { label: session.label } });
  const [requisites, setRequisites] = useState<number[]>(session.requisites);
  const [error, setError] = useState('');
  const [patchSession, { isLoading }] = usePatchTgSessionMutation();

  const onSubmit: SubmitHandler<{ label: string }> = async (data) => {
    setError('');
    try {
      await patchSession({ id: session.id, label: data.label, requisites }).unwrap();
      setActive(false);
    } catch (requestError) {
      setError(getErrorText(requestError, 'Не удалось сохранить'));
    }
  };

  return (
    <FormProvider {...formMethods}>
      <ModalDefault title={`Аккаунт ${session.phone}`} titleMargin={'16px'} active={active} setActive={setActive}>
        {isLoading ? (
          <Loading />
        ) : (
          <form onSubmit={formMethods.handleSubmit(onSubmit)}>
            <ControlledInput title={'Название'} blockStyle={{ marginBottom: '16px' }} placeholder={'Название'} name={'label'} type={'text'} />
            <RequisitesSelect value={requisites} onChange={setRequisites} />
            <Button text={'Сохранить'} type={'submit'} />
            {error && <div className={styles.error}>{error}</div>}
          </form>
        )}
      </ModalDefault>
    </FormProvider>
  );
};

export default EditSessionModal;
